import { z } from 'zod';

const UserBaseModel = z.object({
  email: z.string(),
  name: z.string(),
  organizations: z
    .object({
      name: z.string(),
      flattenExternalSystemCode: z.string(),
    })
    .array(),
});

const UserModel = UserBaseModel.extend({
  modifiedAt: z.string().nullable().optional(),
});

export const UsersListModel = UserModel.array();

export const UsersListWithUploadResultsModel = UserBaseModel.extend({
  results: z.string().array(),
}).array();

export const UsersListsWithUploadResultsModel = z.object({
  users: UsersListWithUploadResultsModel,
  allUsers: UsersListWithUploadResultsModel,
});
